<template>
  <b-modal
    :ref="(curWidget) ? 'editPivotTableModal' : 'addPivotTableModal'"
    hide-footer
    centered
    :title="(curWidget) ? 'Update Pivot Table widget' : 'Create Pivot Table widget'"
    >
    <b-form @submit.prevent="submit" novalidate>
      <b-form-group>
        <div role="group">
          <div class="col-form-label">
            <b-form-checkbox
              v-model="typeHeaders"
              >
              Column headers:
            </b-form-checkbox>
          </div>
          <input-tag
            v-if="typeHeaders"
            :tags.sync="headers"
            :read-only="inProgress"
            class="form-control"
            v-model="$v.headers.$model"
            :class="{ 'is-invalid': $v.headers.$error }"
            />
          <div v-else class="text-info">
            <b><i>Column headers will be taken from very first row of provided sheet</i></b>
          </div>
          <b-form-invalid-feedback v-if="!$v.headers.headersRequired">Column headers are required</b-form-invalid-feedback>
        </div>
      </b-form-group>
      <b-form-group
        label="Data:"
        >
        <input
          type="hidden"
          class="form-control"
          v-model="$v.dataProvided.$model"
          :class="{ 'is-invalid': $v.dataProvided.$error }"
          >
          <div class="pivotTableData">
            <div
              v-for="(val, sheet) in data"
              :key="sheet"
              class="pivotTableData__item"
              >
              <b-form-checkbox
                @change="dataProviderChanged(sheet)"
                v-model="data[sheet]"
                >
                {{ sheet }}
              </b-form-checkbox>
            </div>
          </div>
        <b-form-invalid-feedback v-if="!$v.dataProvided.dataRequired">Data must be provided</b-form-invalid-feedback>
      </b-form-group>
      <b-button
        v-if="curDataProviders"
        type="submit"
        :disabled="inProgress"
        >
        Update
      </b-button>
      <b-button
        v-else
        type="submit"
        :disabled="inProgress"
        >
        Save
      </b-button>
    </b-form>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'
// services
import db from '@/services/db'
// helpers
import eventBus from '@/helpers/event-bus'

let $ = window.$

export default {
  props: ['curHeaders', 'curDataProviders', 'curWidget'],
  data () {
    return {
      headers: [],
      data: {},
      dataProvided: false,
      inProgress: false,
      typeHeaders: true
    }
  },
  computed: {
    ...mapState([
      '$sheets',
      'currentTab'
    ])
  },
  watch: {
    $sheets () {
      this.fillData()
    },
    curDataProviders () {
      this.fillData()
      for (let provider of this.curDataProviders) {
        this.data[provider] = true
        this.dataProvided = true
      }
    },
    curHeaders () {
      if (!this.curHeaders) {
        this.typeHeaders = false
        return
      }
      this.headers = this.curHeaders
    }
  },
  methods: {
    fillData () {
      this.data = {}
      for (let sheet in this.$sheets) {
        this.data[sheet] = false
      }
    },
    submit () {
      this.$v.$touch()
      if (this.$v.$invalid || this.inProgress) return
      this.inProgress = true

      let vm = this
      let data = {
        dataProviders: [],
        tab: vm.currentTab
      }

      if (this.typeHeaders) data.headers = this.headers
      if (this.curWidget) data.table = this.curWidget

      for (let sheet in this.data) {
        if (this.data[sheet]) data.dataProviders.push(sheet)
      }

      let createCallback = () => {
        this.$store.commit('deleteProcess', 'createPivot')
        this.headers = []
        this.fillData()
        this.inProgress = false
        this.$nextTick(() => {
          if (this.$refs.addPivotTableModal) this.$refs.addPivotTableModal.hide()
          this.$v.$reset()
        })
      }

      let updateCallback = () => {
        this.$store.commit('deleteProcess', 'updatePivot')
        this.$nextTick(() => {
          if (this.$refs.editPivotTableModal) this.$refs.editPivotTableModal.hide()
          this.$v.$reset()
        })
        this.inProgress = false
      }

      if (this.curWidget) {
        this.$store.commit('addProcess', {
          process: 'updatePivot',
          message: 'Updating'
        })
        db.pivotTable.update(data, updateCallback)
      } else {
        this.$store.commit('addProcess', {
          process: 'createPivot',
          message: 'Creating'
        })
        db.pivotTable.create(data, createCallback)
      }
    },
    dataProviderChanged () {
      this.$nextTick(() => {
        for (let sheet in this.data) {
          if (this.data[sheet]) {
            this.dataProvided = true
            return
          }
        }
        this.dataProvided = false
      })
    }
  },
  created () {
    this.fillData()

    eventBus.$on('showAddPivotTableModal', () => {
      this.fillData()
      if (this.$refs.addPivotTableModal) this.$refs.addPivotTableModal.show()
    })
    eventBus.$on('showEditPivotTableModal', () => {
      if (this.$refs.editPivotTableModal) this.$refs.editPivotTableModal.show()
    })
  },
  validations: {
    headers: {
      headersRequired (val) {
        if (!this.typeHeaders) return true
        return val.length > 0
      }
    },
    dataProvided: {
      dataRequired (val) {
        return val
      }
    }
  },
  mounted () {
    if (this.$refs.addPivotTableModal) {
      $(this.$refs.addPivotTableModal['$el']).appendTo('body')
    }
    if (this.$refs.editPivotTableModal) {
      $(this.$refs.editPivotTableModal['$el']).appendTo('body')
    }
  },
  beforeDestroy () {
    if (this.$refs.addPivotTableModal) {
      $(this.$refs.addPivotTableModal['$el']).remove()
    }
    if (this.$refs.editPivotTableModal) {
      $(this.$refs.editPivotTableModal['$el']).remove()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~$scss/globals';

.pivotTableData {
  @include cf;
  &__item {
    @include span(4);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/PivotTable.vue